function showCartLoader() {
  document.getElementById('cartDrawerLoader').classList.add('active');
}
function hideCartLoader() {
  document.getElementById('cartDrawerLoader').classList.remove('active');
}

document.addEventListener('click', function (e) {
  var customRemoveBtn = e.target.closest('.custom_remove');
  if (!customRemoveBtn) return;

  e.preventDefault();

  var cartItem = customRemoveBtn.closest('.cart-items__price');
  console.log('cartItem', cartItem);
  
  var defaultRemoveBtn = cartItem?.querySelector('.default_remove_button');

  if (defaultRemoveBtn) {
    defaultRemoveBtn.click(); // 🚀 triggers native ajax remove
  }
});
document.addEventListener("change", function (e) {
  const toggle = e.target.closest(".shipping-protection-toggle");
  if (!toggle) return;
  if (toggle.checked) {
    const buttonShipping = document.querySelector(".shipping-protection-btn");
    if (buttonShipping) {
      buttonShipping.click();
    }
  }else if(document.querySelector('.cart-items__remove.remove--shipping-protection')!=null){
    const removeShipping = document.querySelector('.cart-items__remove.remove--shipping-protection')
    if (removeShipping) {
      removeShipping.click();
    }
  }
});

document.addEventListener('click', function (e) {
  var checkoutButtonObj = e.target.closest('.cart__checkout-button');
  if (!checkoutButtonObj) return;
  var cartItem = document.querySelector('.checkout-text-custom');
  if(cartItem){
    cartItem.style.display="none";
  }
  var loaderDiv = document.querySelector('.checkout-loader-custom');
  if (loaderDiv) {
    loaderDiv.classList.remove('hidden');
  }
});

// FREE PRORUCT REMOVE FOR THAT START
document.addEventListener('click', function (e) {
  var removeButtonObj = e.target.closest('.remove_main_product');
  if (!removeButtonObj) return;
  showCartLoader();
});
if (document.querySelector('.product-information [name="properties[_free_gift]"]')) {
  const getFreeProducts = document.querySelector('.product-information [name="properties[_free_gift]"]').value;

  if (getFreeProducts) {
    
    const freeVariantIds = getFreeProducts
      .split(/[\n,]+/)
      .map(v => v.trim())
      .filter(Boolean)
      .map(Number);

    let running = false;

    async function refreshCartDrawer() {
      const cartEl = document.querySelector('cart-items-component');
      if (cartEl && typeof cartEl.onLineItemRemove === 'function') {
        showCartLoader();
        cartEl.onLineItemRemove(getFreeProducts.length);
      }
    }

    async function handleFreeProductCheck() {

      if (running) return;
      running = true;

      let cart = await fetch('/cart.js').then(r => r.json());

      let paidProducts = 0;
      let changed = false;

      cart.items.forEach(item => {
        if (!freeVariantIds.includes(item.variant_id)) {
          paidProducts += item.quantity;
        }
      });
     
      for (const item of cart.items) {
        if (freeVariantIds.includes(item.variant_id)) {
          /* remove free product if no paid products */
          if (paidProducts === 0) {
            showCartLoader();
            await fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                id: item.key,
                quantity: 0
              })
            });

            changed = true;
          }

          /* keep free product quantity only 1 */
          else if (item.quantity > 1) {

            await fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                id: item.key,
                quantity: 1
              })
            });

            changed = true;
            
          }
        }
      }

      /* REFRESH CART DATA AFTER CHANGE */
      if (changed) {
        cart = await fetch('/cart.js').then(r => r.json());
        
      }

      /* check if free product still exists */
      const freeExists = cart.items.some(item =>
        freeVariantIds.includes(item.variant_id)
      );

      document.querySelectorAll('.free-product-custom').forEach(input => {

        const qty = input.parentElement.querySelector('.hidden-input-custom');

        if (freeExists) {
          input.disabled = true;
          if (qty) qty.disabled = true;
        } else {
          input.disabled = false;
          if (qty) qty.disabled = false;
        }

      });

      if (changed) {
        setTimeout(() => {
          refreshCartDrawer();
        }, 300);
        setTimeout(() => {
          hideCartLoader();
        }, 2000);
      }

      running = false;
    }

    const originalFetch = window.fetch;

    window.fetch = function () {

      return originalFetch.apply(this, arguments).then(res => {

        const url = arguments[0];

        if (
          typeof url === "string" &&
          (
            url.includes('/cart/add') ||
            url.includes('/cart/change') ||
            url.includes('/cart/update')
          )
        ) {
          handleFreeProductCheck();
        }

        return res;

      });

    };

    document.addEventListener('DOMContentLoaded', handleFreeProductCheck);

  }
}
// FREE PRORUCT REMOVE FOR THAT END


// H5: Judge.me preview badge — force rating text, keep review count dynamic.
(function () {
  var RATING_TEXT = 'Rated as "Excellent" 4.8/5';

  function rewriteAll() {
    document.querySelectorAll('.jdgm-prev-badge .jdgm-prev-badge__text').forEach(function (el) {
      var badge = el.closest('.jdgm-prev-badge');
      var count = badge && badge.getAttribute('data-number-of-reviews');
      var target = count ? RATING_TEXT + ' (' + count + ' reviews)' : RATING_TEXT;
      if (el.textContent !== target) el.textContent = target; // guard prevents observer loops
    });
  }

  rewriteAll();
  var mo = new MutationObserver(rewriteAll);
  mo.observe(document.body, { childList: true, subtree: true, characterData: true });
  // Judge.me finishes its badge rewrite well within a few seconds; stop observing after 15s.
  setTimeout(function () { mo.disconnect(); rewriteAll(); }, 15000);
})();
